package com.macrofocus.eflux.ui.bar

import com.macrofocus.eflux.TableType
import com.macrofocus.eflux.components.EFluxContext
import mui.icons.material.GpsFixedTwoTone
import mui.icons.material.HubTwoTone
import mui.icons.material.LocalHospitalTwoTone
import mui.icons.material.PolylineTwoTone
import mui.material.Box
import mui.material.FabColor
import mui.system.sx
import org.mkui.react.useProperty
import react.FC
import react.Props
import react.useRequired
import web.cssom.*

external interface SouthFabBarProps : Props {
}

public val SouthFabBar = FC<SouthFabBarProps> { props ->
    val context = useRequired(EFluxContext)

    val (expert, _) = useProperty(context.dataLoader.exportMode)

    // Maintain toggle states
    val (tableSelected, setTableSelected) = useProperty(context.showTable)
    val (tableType, setTableType) = useProperty(context.configuration.tableType)

    Box {
        sx {
            position = Position.absolute
            bottom = 16.px
            right = 16.px
            display = Display.flex
            flexDirection = FlexDirection.row
            gap = 0.px
        }

        if(expert) {
            LiquidFab {
                color = if (tableSelected && tableType == null) FabColor.primary else FabColor.default

//                ariaLabel = "Coordinates"
                GpsFixedTwoTone {}

                onClick = {
                    if(tableSelected && tableType != null) {
//                        setTableType(null)
                    }
                    setTableSelected(!tableSelected)
                }
            }
        }

        LiquidFab {
            color = if (tableSelected && tableType == TableType.CROSSBORDER) FabColor.primary else FabColor.default

            sx {
                marginRight = -6.px
                if(tableSelected && tableType == TableType.CROSSBORDER) {
                    zIndex = "2000".unsafeCast<ZIndex>()
                }
            }

//            ariaLabel = "Cross-border"
            LocalHospitalTwoTone {}

            onClick = {
                if(!tableSelected || (tableSelected && tableType != TableType.CROSSBORDER)) {
                    setTableType(TableType.CROSSBORDER)
                }
                if(tableSelected && tableType == TableType.CROSSBORDER) {
                    setTableSelected(false)
                } else {
                    setTableSelected(true)
                }
            }
        }

        LiquidFab {
            color = if (tableSelected && tableType == TableType.BUS) FabColor.primary else FabColor.default

            sx {
                if(tableSelected && tableType == TableType.BUS) {
                    zIndex = "2000".unsafeCast<ZIndex>()
                }
            }

//            ariaLabel = "Substations"
            HubTwoTone {}

            onClick = {
                if(!tableSelected || (tableSelected && tableType != TableType.BUS)) {
                    setTableType(TableType.BUS)
                }
                if(tableSelected && tableType == TableType.BUS) {
                    setTableSelected(false)
                } else {
                    setTableSelected(true)
                }
            }
        }

        LiquidFab {
            color = if (tableSelected && tableType == TableType.BRANCH) FabColor.primary else FabColor.default

            sx {
                marginRight = -6.px
                if(tableSelected && tableType == TableType.BRANCH) {
                    zIndex = "2000".unsafeCast<ZIndex>()
                }
            }

//            ariaLabel = "Lines"
            PolylineTwoTone {}

            onClick = {
                if(!tableSelected || (tableSelected && tableType != TableType.BRANCH)) {
                    setTableType(TableType.BRANCH)
                }
                if(tableSelected && tableType == TableType.BRANCH) {
                    setTableSelected(false)
                } else {
                    setTableSelected(true)
                }
            }
        }
    }
}